// extracted by mini-css-extract-plugin
module.exports = {"heading":"AppBarLanding_heading__ozOI5","logo":"AppBarLanding_logo__S9wtg","list":"AppBarLanding_list__1ICnl"};